import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { playClick, playSuccess } from '../utils/SoundManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function BlockedListPage() {
  const navigate = useNavigate();
  const [blocked, setBlocked] = useState([]);
  const [loading, setLoading] = useState(true);

  const getHeaders = () => {
    const uid = localStorage.getItem('userId');
    return uid ? { 'X-User-Id': uid } : {};
  };

  useEffect(() => {
    fetchBlocked();
  }, []);

  const fetchBlocked = async () => {
    try {
      const r = await axios.get(`${BACKEND_URL}/api/blocked/list`, {
        withCredentials: true, headers: getHeaders()
      });
      setBlocked(r.data.blocked || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const unblock = async (userId) => {
    if (!window.confirm('هل تريد إلغاء تجاهل هذا العضو؟')) return;
    playClick();
    try {
      await axios.post(`${BACKEND_URL}/api/blocked/remove`, { user_id: userId }, {
        withCredentials: true, headers: getHeaders()
      });
      setBlocked(prev => prev.filter(b => b.user_id !== userId));
      playSuccess();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>وِداد</h1>
          <button className="nav-link" onClick={() => navigate('/dashboard')} data-testid="blocked-back-btn">
            ← الرئيسية
          </button>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '720px' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '54px', marginBottom: '8px' }}>🚫</div>
          <h1 style={{ fontSize: '26px', color: 'var(--text-dark)', marginBottom: '6px' }}>
            قائمة التجاهل
          </h1>
          <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
            الأعضاء الذين قمت بحظرهم لن يستطيعوا التواصل معك أو رؤية ملفك
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="floating" style={{ fontSize: '36px' }}>⏳</div>
          </div>
        ) : blocked.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '50px 20px', borderRadius: '20px' }}>
            <div style={{ fontSize: '60px', marginBottom: '14px', opacity: 0.5 }}>🌿</div>
            <h3 style={{ color: 'var(--text-dark)', marginBottom: '8px' }}>قائمتك نظيفة</h3>
            <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
              لا يوجد أي عضو محظور حالياً
            </p>
          </div>
        ) : (
          <div className="card" style={{ padding: '12px', borderRadius: '16px' }}>
            {blocked.map((b, idx) => (
              <div
                key={b.user_id}
                data-testid={`blocked-item-${b.user_id}`}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px',
                  padding: '14px', borderRadius: '12px',
                  borderBottom: idx < blocked.length - 1 ? '1px solid var(--border-color)' : 'none'
                }}
              >
                <div style={{
                  width: '46px', height: '46px', borderRadius: '50%',
                  background: 'rgba(150, 150, 150, 0.2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--text-light)', fontSize: '20px', fontWeight: '700',
                  filter: 'grayscale(1)'
                }}>
                  {b.name?.charAt(0) || '👤'}
                </div>
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: 0, fontSize: '15px', color: 'var(--text-dark)' }}>{b.name}</h4>
                  <p style={{ margin: '2px 0 0', fontSize: '12px', color: 'var(--text-light)' }}>
                    {b.age ? `${b.age} سنة` : ''}{b.city ? ` · ${b.city}` : ''}
                  </p>
                </div>
                <button
                  data-testid={`unblock-${b.user_id}`}
                  onClick={() => unblock(b.user_id)}
                  className="btn btn-outline"
                  style={{ padding: '8px 14px', fontSize: '12px' }}
                >
                  إلغاء التجاهل
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default BlockedListPage;
